import React, {useEffect, useState} from 'react';
import {numberWordSuffix} from "../../utils/word";

// Обратный отсчет до
const Countdown = ({date, variant = "dark"}) => {
    const calculateTimeLeft = () => {
        const difference = +date - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    const [year] = useState(date.getFullYear());

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => {
            clearTimeout(timer);
        }
    });

    const timerComponents = [];
    Object.keys(timeLeft).forEach((interval) => {
        if (!timeLeft[interval]) {
            return;
        }

        timerComponents.push(
            <span>
        {timeLeft[interval]} {interval}{" "}
      </span>
        );
    });

    const isLight = variant === "light";

    const containerClassName = isLight
        ? "mx-4 mb-2 flex flex-col rounded-lg border border-gray-300/60 bg-gray-100/80 px-3 pt-3"
        : "mx-4 mb-2 flex flex-col rounded-lg border border-gray-300/60 bg-gray-100 px-3 pt-3";
    const titleClassName = isLight ? "text-gray-700 text-sm" : "text-gray-700 text-sm";
    const timerRowClassName = isLight
        ? "p-4 flex flex-row mb-2 justify-center text-gray-700"
        : "p-4 flex flex-row mb-2 justify-center text-gray-700";
    const digitsClassName = isLight ? "text-2xl font-bold text-gray-900" : "text-2xl font-bold text-gray-900";

    return (
        <div className={containerClassName}>
            <div className={"flex flex-row"}>
                <p className={titleClassName}>Жизни на сегодня закончились. Следующая игра будет доступна через:</p>
            </div>

            <div className={timerRowClassName}>
                <div className={"flex flex-col items-center justify-center h-12 w-20 px-4"}>
                    <div className={digitsClassName}>{timeLeft.hours}</div>
                    <span>{ numberWordSuffix(timeLeft.hours, ["час", "часа", "часов"]) }</span>
                </div>
                <div className={"flex flex-col items-center justify-center h-12 w-20 px-4"}>
                    <div className={digitsClassName}>{timeLeft.minutes}</div>
                    <span>{ numberWordSuffix(timeLeft.minutes, ["минуту", "минуты", "минут"]) }</span>
                </div>
                <div className={"flex flex-col items-center justify-center h-12 w-20 px-4"}>
                    <div className={digitsClassName}>{timeLeft.seconds}</div>
                    <span>{ numberWordSuffix(timeLeft.seconds, ["секунду", "секунды", "секунд"]) }</span>
                </div>
            </div>
        </div>
    );
}

export default Countdown;
